import api from '../api.js';
import { ask, notify } from '../../versa/msgbox.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#program #company_id		{ width: 10rem;		}
			#program #id				{ width: 5rem; text-align: right;	}
			#program #name				{ width: 25rem;		}
			#program #code				{ width: 10rem;		}
			#program #is_default		{ width: 4rem;		}
		</style>
		<form id="program" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do programa">Programa
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do programa">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Código (opcional)">Código
					<input id="code" type="text" placeholder="PADRAO">
				</label>
				<label title="Programa padrão da empresa">Padrão
					<input id="is_default" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_program_delete" title="Excluir programa">Excluir</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#program',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const root = () => formset.dialog?.getNode?.();
			const getCompanyId = () => formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
			const getId = () => root()?.querySelector?.('#id')?.value;
			const deleteProgram = async () => {
				const company_id = getCompanyId(), id = getId();
				if (!company_id || !id) return;
				ask('Excluir este programa? Só é possível excluir programas sem registros vinculados (produtos, lotes, pedidos, entradas).', 'Excluir', async (answer) => {
					if (answer !== 'Y') return;
					const resp = await api.call(api.delete_program, company_id, id);
					if (resp !== undefined) {
						formset.destroy();
						document.dispatchEvent(new CustomEvent('programs:reload'));
					}
				});
			};
			root()?.addEventListener?.('click', (ev) => {
				if (ev.target?.closest?.('.bn_program_delete')) { ev.preventDefault(); ev.stopPropagation(); deleteProgram(); return; }
			});
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#name' }, types: [] },
		{ properties: { selector: '#code' }, types: [] },
		{ properties: { selector: '#is_default' }, types: [types.checkbox()] },
	]
};
